export const BATCH_SAVE = 'BATCH_SAVE';
export const BATCH_CLEAR = 'BATCH_CLEAR';
